import BaseHelper from './BaseHelper'
import ResizeObserver from 'resize-observer-polyfill'

export default class SizeHelper extends BaseHelper {
  static configName = 'SizeHelper'

  static init() {
    let self = this
    const resizeObserver = new ResizeObserver(() => {
      let newSize = self.$root.getBoundingClientRect()
      if (JSON.stringify(self.size) !== JSON.stringify(newSize)) {
        if (newSize && newSize.width !== 0 && newSize.height !== 0) {
          self.size = newSize
          self._draw()
        }
      }
    })

    resizeObserver.observe(self.$root.parentNode)
  }
  static beforeDraw() {
    this.size = this.$root.getBoundingClientRect()
  }
  static draw() {}
  static afterDraw() {}
}
